import { computed, ref } from 'vue';

import { SlideInformation } from '../models/entities/text-carousel.model';
//import { useStore } from '../composables/store.composable';
import { bookingSlotsResponse } from '../../../shared/src/mocks/booking.service.mock';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars
const useDatetimePicker = (props, { emit }) => {
  //const { commit } = useStore();
  // ----------------------------------------
  // variables

  const datePickerOpen = ref(false);

  const activeCalendarPage = ref(0);

  const defaultSelectedDates = ref({});

  let firstLoad = true;

  // TODO Change implementation of default selected slot when using real data
  const defaultSelectedSlot = bookingSlotsResponse[0];

  // ----------------------------------------
  // computed
  const getSelectedDates = computed(() => {
    return props.selectedDates ?? defaultSelectedDates.value;
  });

  const getSelectedSlot = computed(() => {
    if (firstLoad && !props.selectedSlot) {
      emit('selectedSlot', defaultSelectedSlot.value);
      firstLoad = false;
    }
    return props.selectedSlot ?? defaultSelectedSlot.value;
  });

  // ----------------------------------------
  // methods
  const changeDate = (day?: Date) => {
    datePickerOpen.value = false;
    if (props.selectedDates) {
      emit('changeDate', day);
    } else if (props.isOptional) {
      emit('changeDate', day);
      defaultSelectedDates.value = { start: day };
    } else {
      defaultSelectedDates.value = { start: day };
    }
  };

  const changeSheet = (page: SlideInformation) => {
    activeCalendarPage.value = page.index;
    emit('changeSheet', page);
  };

  const maskCalendarSection = (): void => {
    emit('maskCalendar');
  };

  const onSelectedSlot = (value: string): void => {
    if (props.selectedSlot) {
      emit('selectedSlot', value);
    } else {
      defaultSelectedSlot.value = value;
    }
  };

  const unmaskCalendarSection = (): void => {
    emit('unmaskCalendar');
  };

  const toggleDatePicker = (state: boolean): void => {
    datePickerOpen.value = state;
  };

  return {
    activeCalendarPage,
    changeDate,
    changeSheet,
    datePickerOpen,
    getSelectedDates,
    getSelectedSlot,
    maskCalendarSection,
    onSelectedSlot,
    toggleDatePicker,
    unmaskCalendarSection,
  };
};

export default useDatetimePicker;
